// extracted by mini-css-extract-plugin
var _1 = "ki4efDK7GZV0SHl7nNst";
export { _1 as "carouselWrapper" }
